import Vue from 'vue'
import { BootstrapVue, PopoverPlugin, IconsPlugin }  from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(PopoverPlugin)
Vue.use(IconsPlugin)

export default {
    components: {
        PopoverPlugin: PopoverPlugin,
        IconsPlugin: IconsPlugin,        
    }
}